import { DemoPortfolioPerformanceChart } from '@/components/PortfolioPerformanceChart';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

import { DemoOverviewHeader } from './components/OverviewHeader';
import { OverviewSnowflake } from './components/OverviewSnowflake';

interface Props {
  portfolio: Portfolio;
}

export const DemoPortfolioOverview = ({ portfolio }: Props) => {
  return (
    <div
      data-cy-id="portfolio-overview"
      className="grid grid-rows-[auto_auto] gap-x2 md:grid-cols-[auto_32%] md:grid-rows-[auto]"
    >
      <div className="grid bg-legacy-noir lg:gap-x0_5 lg:rounded-x1">
        <DemoOverviewHeader portfolio={portfolio} />
        <DemoPortfolioPerformanceChart
          portfolioId={portfolio.id}
          benchmarkType={portfolio.analysis.benchmarkType}
          benchmark={portfolio.analysis.benchmark}
        />
      </div>
      <div className="grid rounded-x1 bg-legacy-noir p-x2">
        <OverviewSnowflake portfolio={portfolio} />
      </div>
    </div>
  );
};
